import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="w-full bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="flex justify-between items-center py-4" data-id="element-129">
          <div className="flex items-center" data-id="element-130">
            <span className="text-2xl font-bold text-blue-900" data-id="element-131">
              <span className="text-blue-600" data-id="element-132">极客</span>quant
            </span>
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-133">
            <a href="#features" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-134">
              量化服务
            </a>
            <a href="#about" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-135">
              关于我们
            </a>
            <a href="#results" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-136">
              业绩展示
            </a>
            <a href="#contact" className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium" data-id="element-137">
              联系我们
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-138">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-139">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-140" /> : <MenuIcon className="h-6 w-6" data-id="element-141" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-142">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-id="element-143">
            <a href="#features" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-144">
              量化服务
            </a>
            <a href="#about" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-145">
              关于我们
            </a>
            <a href="#results" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-146">
              业绩展示
            </a>
            <a href="#contact" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-147">
              联系我们
            </a>
          </div>
        </div>}
    </header>;
};